import { DEVICE_TYPE } from '@/types';


export const sideBar = (set) => {
    return {
        showSideBar: false,
        setShowSideBar: (next: Boolean) => {
            set((state) => ({
                showSideBar: next,
            }));
        },
    };
};
